import { render, staticRenderFns } from "./departUser.vue?vue&type=template&id=15033fed&scoped=true"
import script from "./departUser.vue?vue&type=script&lang=js"
export * from "./departUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15033fed",
  null
  
)

export default component.exports